export const COLOR = {
    main: "#EA0F08",
    light: "#FFE7E6",
    medium: "",
    grey: "",
    green: "#1EA006"
};